"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Site = exports.OtherService = exports.CommercialService = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const service_location_1 = require("../common/service-location");
exports.CommercialService = typebox_1.Type.Object({
    equipmentMaterial: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentTypeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.OtherService = typebox_1.Type.Object({
    equipmentMaterial: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentTypeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.Site = typebox_1.Type.Object({
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    dealsheetID: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceLocation: typebox_1.Type.Optional(service_location_1.ServiceLocationTransport),
    commServices: typebox_1.Type.Optional(typebox_1.Type.Array(exports.CommercialService)),
    otherServices: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OtherService)),
    metadata: common_1.MetaData,
});
//# sourceMappingURL=site-transport.js.map